module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-binary-cbf05fa8.svg";